import WeaDateGroup from "./index-old";
import WeaDateGroupMobx from "./index-mobx";
import middleware from "../../middleware";

class main extends React.Component {
  static defaultProps = {
    isMobx: false
  };
  constructor(props) {
    super(props);
  }
  render() {
    return this.props.isMobx ? (
      <WeaDateGroupMobx {...this.props} />
    ) : (
      <WeaDateGroup {...this.props} />
    );
  }
}

const Com = middleware(main, "WeaDateGroup");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-date-group/index.js